var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Drawer'),_c('AppBar'),_c('v-main',[_c('v-slide-x-reverse-transition',{attrs:{"hide-on-leave":"","origin":"left right"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }